export default __webpack_public_path__ + "static/media/call_branded.d74f2385.svg";